import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IsNilPipe } from './is-nil.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [IsNilPipe],
  exports: [IsNilPipe],
})
export class IsNilPipeModule {}
